// extracted by mini-css-extract-plugin
export default {"icon":"LoadingIcon_icon__i2fYC","animate":"LoadingIcon_animate__CA-0d"};